export default "__VITE_ASSET__DvSIUMXk__"